/**
 * @class ActionTextStringAssets A collection of string assets that pertain to action text fields
 */
 export class ActionTextStringAssets {
    static resendAccountVerificationEmail: string = 'Re-send account verification email message';
    static sendSigninWithEmailLinkEmail: string = 'Sign-in with Email Link (no password required)';
    static forgotPassword: string = 'Forgot password? (password reset)';
 }